import { MCA_ENTITIES } from "../data/mcaEntities";
import { isEntityMcaLocked } from "../components/mca/mcaApprovalLabels";

export const MCA_DRAFT_STATUSES = new Set(["DFT", "PENDING", "DRAFT"]);

export const MCA_API_ENTITIES = new Set(
  MCA_ENTITIES.map((entity) => entity.apiEntity ?? entity.value)
);

export const isMcaDraftStatus = (status) =>
  status != null && MCA_DRAFT_STATUSES.has(String(status).toUpperCase());

export const resolveMcaEntityKey = (apiEntity, mcaEntity) =>
  mcaEntity ?? apiEntity;

export const canSubmitMcaCreateLocally = ({
  apiEntity,
  formMode,
  entity,
  isDirty = false,
}) => {
  if (!apiEntity || !MCA_API_ENTITIES.has(apiEntity)) {
    return { eligible: false, reason: "not_mca_entity" };
  }
  if (formMode !== "edit" || !entity?._id) {
    return { eligible: false, reason: "not_edit_mode" };
  }
  if (isEntityMcaLocked(entity)) {
    return { eligible: false, reason: "mca_locked" };
  }
  if (!isMcaDraftStatus(entity?.status)) {
    return { eligible: false, reason: "not_draft" };
  }
  if (isDirty) {
    return {
      eligible: true,
      reason: "unsaved_changes",
      submitDisabled: true,
    };
  }
  return { eligible: true, reason: null, submitDisabled: false };
};

/** Keep edit form open after create when MCA deferred draft needs Submit for Approval. */
export const shouldKeepFormOpenAfterMcaCreate = ({
  apiEntity,
  savedStatus,
  mcaIntercepted = false,
}) => {
  if (mcaIntercepted) return false;
  if (!apiEntity || !MCA_API_ENTITIES.has(apiEntity)) return false;
  return isMcaDraftStatus(savedStatus);
};

/** Merge create response into form values so Submit for Approval is available before loadFormData. */
export const syncFormAfterMcaCreate = ({ formValues, createData }) => {
  if (!createData || typeof createData !== "object") return formValues;
  return {
    ...formValues,
    ...createData,
    _id: createData._id ?? formValues?._id,
    status: createData.status ?? formValues?.status,
    mcaPending: createData.mcaPending ?? formValues?.mcaPending ?? false,
    mcaRequestId: createData.mcaRequestId ?? formValues?.mcaRequestId ?? null,
  };
};

/** Only show Submit for Approval when a CREATE MCA process actually matches. */
export const shouldShowMcaSubmit = ({ localCheck, matchCreate, matchLoading }) => {
  if (!localCheck.eligible) return false;
  if (matchLoading || !matchCreate) return false;
  return !!matchCreate.match;
};

export const getMcaSubmitDisabledReason = ({
  localCheck,
  matchCreate,
  matchLoading,
  t = (value) => value,
}) => {
  if (localCheck.reason === "unsaved_changes") {
    return t("Save your changes before submitting for approval");
  }
  if (localCheck.eligible && matchLoading && !matchCreate) {
    return t("Checking approval process...");
  }
  if (localCheck.eligible && matchCreate && !matchCreate.match) {
    if (matchCreate.reason === "only_update_processes") {
      return t(
        "No CREATE approval process applies. Your approval processes for this entity use Action UPDATE — set Action to CREATE for Submit for approval."
      );
    }
    return t("No CREATE approval process applies to this record");
  }
  return null;
};
